import { useAuth } from '../hooks/useAuth';
import { Navigate } from 'react-router-dom';
export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/dashboard/painel-notas" replace />;
  }

  if (user && user.role_id !== 1) {
    return <Navigate to="/dashboard/painel-notas" replace />;
  }

  return children;
};
